import React from 'react';
import PlusComponent from "../../myComp/PlusComponent";
import ContentSettings from "../../myComp/ContentSettings";

class PriceListGet extends PlusComponent {
  constructor(props) {
    super(props, "contentPriceList");         
  }

  render(){     
    return (
        <div>
          <ContentSettings {...this.props} controller="contentPriceList"></ContentSettings>
        </div>
      )
    }
}

export default PriceListGet;